import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  REFERRAL_SOURCE_EXTERNAL,
  REFERRAL_SOURCE_QUERY_PARAM,
} from 'services/referrals/referral-source.constants';

/**
 * Reads the identity of the referral currently being viewed from the URL:
 * the `:id` route param and an optional `?source=external` query param that
 * indicates the row lives in the `external_referral` table.
 *
 * Keeping the flag in the URL (instead of `location.state`) means any hook in
 * the details tree can ask "is this an external referral?" without the caller
 * threading the flag through, and the page survives refresh/deep-links.
 */
export function useReferralSource() {
  const { id } = useParams<{ id?: string }>();
  const { search } = useLocation();

  const isExternalReferral = useMemo(
    () =>
      new URLSearchParams(search).get(REFERRAL_SOURCE_QUERY_PARAM) ===
      REFERRAL_SOURCE_EXTERNAL,
    [search]
  );

  return {
    id: id ?? '',
    isExternalReferral,
  };
}
